<script>
  export let idUnico = 'split';
  export let color = '';
  export let colorido = '';
  export let content;
  import navegacaoStore from '../../store';
  import { onMount } from 'svelte';

  let grupos;
  let grupo = [];

  let botoes = [];

  let images = [];

  let dados;

  let splitImg = true;

  let li_begin;

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  content = content.replace('Cannabis', '<i>Cannabis</i>');
  content = content.replace('ecstasy', '<i>ecstasy</i>');

  grupos = content.split(';;');

  grupos.forEach((element, index) => {
    if (element.trim() != 0) {
      if (element.includes('::')) {
        grupo[index] = element.split('::');

        botoes[index] = grupo[index][0];

        li_begin = grupo[index][1].search('•');
        if (li_begin != -1) {
          grupo[index][1] = grupo[index][1].replaceAll('•', '<br><br>•&nbsp;&nbsp;');
        }

        splitImg = false;
      } else {
        botoes[index] = '';
        grupo[index] = element;
        splitImg = true;
        images[index] = dados.splitPath + (index + 1) + '.svg';
      }
    }
  });

  let root;

  const setColor = (element, cor) => {
    element.style.setProperty('--COR_MODULO', `var(--${cor})`);
    element.style.setProperty('--COR_MODULO_FORTE', `var(--${cor}_FORTE)`);
    element.style.setProperty('--COR_MODULO_FRACO', `var(--${cor}_FRACO)`);
    element.style.setProperty('--COR_MODULO_SUPER_FRACO', `var(--${cor}_SUPER_FRACO)`);
  };

  onMount(() => {
    if (color) {
      setColor(root, color);
    }

    let split = document.querySelector(`#${idUnico}`);
    let buttons = split.querySelectorAll('.split-btns > div');
    let content = split.querySelectorAll('.split-pane > div');

    const setSize = () =>
      split
        .querySelector('.split-pane')
        .setAttribute('style', `height: ${set_same_height_collection(content) + 180}px`);

    setSize();

    buttons.forEach((element, index) => {
      element.addEventListener('click', () => {
        switchPane(element, content[index]);
        split
          .querySelector('.split-pane')
          .setAttribute(
            'style',
            `height: ${set_same_height_collection(content) + 180}px; background: var(--VERDE_CLARO); border: 2px solid var(--MARROM)`
          );
      });
    });

    if (colorido) {
      for (let i = 0; i < colorido.length; i++) {
        let btnsDiv = root.querySelectorAll('.split-btns > div')[i];
        setColor(btnsDiv, colorido[i]);
      }
      buttons.forEach((element, index) => {
        element.addEventListener('click', () => {
          switchPane(element, content[index]);
          split.querySelector('.split-pane').setAttribute(
            'style',
            // `height: ${set_same_height_collection(content) + 140}px; background: var(--${
            //   colorido[index]
            // }_FORTE)`
            `height: ${set_same_height_collection(content) + 140}px; background: var(--VERDE_CLARO_20)`
          );
        });
      });
    }

    function switchPane(button, content) {
      j$('.split-btns .active').removeClass('active');
      j$('.split-pane .active').removeClass('active');
      // selectedButton.classList.remove('active');
      // selectedContent.classList.remove('active');

      button.classList.add('active');
      content.classList.add('active');
    }

    // content[0].classList.add('active');
  });
</script>

<section class="section" id={idUnico} bind:this={root}>
  <div class="container">
    <div class="row">
      <div class="col-md-10 row split mx-auto">
        <div class="col-md-5 split-btns">
          {#each botoes as b, index}
            <div class:active={index == 10}>
              <div class="btn-label {splitImg ? 'imgBkg' : 'txtBkg'}">
                {#if splitImg}
                  <img src={images[index]} alt="" />
                {:else}
                  <h3>{b}</h3>
                  <i class="fa-solid fa-angles-right" />
                {/if}
              </div>
            </div>
          {/each}
        </div>
        <div class="col-md-7 split-pane">
          <slot />
          {#each grupo as g, index}
            {#if splitImg}
              <div><p>{g}</p></div>
            {:else}
              <div><p>{@html g[1]}</p></div>
            {/if}
          {/each}
          <div class="content-init active">
            <!-- <h3>
              Clique nos botões
              <span class="d-none d-md-inline">ao lado</span>
              <span class="d-inline d-md-none">acima</span>
            </h3> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .split-btns {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-right: 15px;
  }

  .split-btns > :global(div) {
    width: 100%;
    text-align: center;
    padding: 15px 0;
    user-select: none;
    cursor: pointer;
    background: var(--COR_MODULO_FRACO);
    font-family: var(--FONT_INTER);
    transition: all 100ms ease;
    opacity: 0.95;
    margin-bottom: 1px;
  }

  .split-btns > :global(div) {
    /* margin-top: 25px; */
    padding: 8px 16px;
    /* border-style: solid; */
    /* border-width: 1px; */
    background: var(--VERDE_CLARO_20);
    color: var(--MARROM);
    font-size: 16px;
    text-decoration: none;
    border-radius: 30px;
    box-shadow:
      inset 0 0px 0px #999,
      inset 0 -3px 0px var(--VERDE_CLARO);
    /* box-shadow: inset 0 0px 2px #555, inset 0 -3px 0px #1c3f52; */
    font-family: var(--FONT_INTER);
    font-weight: 900;
  }

  .split-btns > :global(div) :global(.txtBkg) {
    /* background: #26536d; */
    padding: 8px 5px;
    border-radius: 6px;
  }

  .split-btns .btn-label {
    display: grid;
    grid-template-columns: 90% 10%;
    align-items: center;
  }

  .split-btns :global(h3) {
    margin: 0;
    padding: 5px;
    color: var(--MARROM);
    /*background-color: var(--COR_MODULO_FORTE);*/
    font-family: var(--FONT_INTER);
    font-weight: 800;
    font-size: 18px;
  }

  .split-btns > :global(div.active),
  .split-btns > :global(div.active:hover) {
    background: var(--VERDE_CLARO);
    opacity: 1;
    cursor: default;
    color: var(--COR_BRANCO);
    box-shadow:
      inset 0 0px 0px #999,
      inset 0 -3px 0px var(--MARROM);
  }

  .split-btns > :global(div:hover) {
    background: var(--VERDE_CLARO_60);
    opacity: 1;
    box-shadow:
      inset 0 0px 0px #999,
      inset 0 -3px 0px var(--MARROM);
  }

  .split-btns > :global(div:hover) > :global(div i) {
    transform: translateX(5px);
    transition: 200ms all ease-in-out;
  }

  .split-btns > :global(div.active) > :global(div i) {
    transform: translateX(5px);
    transition: 200ms all ease-in-out;
  }

  .split-btns :global(div.active svg path) {
    fill: var(--COR_BRANCO);
  }

  .split-btns > :global(div i svg) {
    width: 15px;
    transition: 200ms all ease-in-out;
  }

  .split-btns > :global(div.active h3) {
    color: var(--COR_BRANCO);
  }

  .split-pane {
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); */
    /* border-radius: 20px; */
    padding: 40px;
    background: var(--VERDE_CLARO_20);
    border: 2px solid var(--VERDE_CLARO_60);
    min-height: 100%;
    /* border-top: 2px solid var(--COR_MODULO_SUPER_FRACO); */
    border-radius: 15px;
  }

  .split-pane :global(p) {
    color: var(--COR_BRANCO);
    font-family: var(--FONT_INTER);
    font-weight: 600;
    font-size: 16px;
  }

  .split-pane :global(h4) {
    margin-bottom: 5px;
    color: var(--COR_BRANCO);
    font-family: var(--FONT_INTER);
    font-weight: 700;
    font-size: 24px;
  }

  .split-pane > :global(div) {
    display: none;
  }
  .split-pane > :global(div.active) {
    display: block;
  }

  @media (max-width: 767px) {
    .split-btns > :global(div) {
      margin-top: 10px;
    }
    .split-pane {
      min-height: auto;
      margin-top: 20px;
    }
    .split-btns > :global(div:hover) > :global(div i) {
      padding: 0 10px;
      transform: translate(0px, -5px) rotate(90deg);
      transition: 200ms all ease-in-out;
    }
    .split-btns > :global(div i) {
      transition: 200ms all ease-in-out;
    }
    .split-btns > :global(div.active) > :global(div i) {
      padding: 0 10px;
      transform: translate(0px, -5px) rotate(90deg);
    }
  }
</style>
